// extracted by mini-css-extract-plugin
export default {"desktopContentMaxWidth":"930px","tabletContentMaxWidth":"692px","maxMobile":"712px","maxTablet":"936px"};